import axios from 'axios';

// Create an axios instance
const api = axios.create({
    // baseURL: 'https://localapi.ieu.link/api', // Update with your API base URL
    // baseURL: 'http://localhost:9001/api', // Update with your API base URL
    baseURL: 'https://cbt.ieu.link/api', // Update with your API base URL
});

// Function to set Authorization token
const apiHeader = (headers) => {
    Object.entries(headers).forEach(([label, value]) => {
        api.defaults.headers[label] = value;
    });
};

// Function to handle general requests (GET, POST, etc.)
const apiRequest = async (method, url, data = null, timeout) => {
    try {
        const config = { method, url };

        if (data) {
            config.data = data;  // If there's a payload (e.g., for POST, PUT)
        }

        if (timeout){
            config.timeout = timeout;
        }
        
        const response = await api(config);

        return response.data || response;
    } catch (error) {
        // Menangani error jika permintaan gagal
        if (error.response) {
            // Jika server mengembalikan status error (selain 2xx)
            return error.response.data || error.response.statusText;
        } else if (error.request) {
            // Jika request berhasil dikirim tetapi tidak ada respons
            return { code: `error`, msg : `Tidak ada respons dari server.` };
        } else {
            // Error lain yang terjadi saat membuat permintaan
            return { code: `error`, msg : `Error: ${error.message}` };
        }
    }
};

// Export axios instance, setAuthToken, makeRequest, and handleError
export { api, apiRequest, apiHeader };
